export class Throttle {
  private timeoutId: ReturnType<typeof setTimeout> | null = null
  private lastCallTime = 0
  private lastFn: (() => void) | null = null

  constructor(
    private readonly wait: number,
    private readonly noImmediate = false
  ) {}

  run(fn: () => void): void {
    const now = Date.now()

    const firstNoImmediate = this.noImmediate && this.lastCallTime === 0
    const remaining = this.wait - (now - this.lastCallTime)

    if (!firstNoImmediate && remaining <= 0) {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId)
        this.timeoutId = null
      }
      this.lastCallTime = now
      fn()
    } else {
      this.lastFn = fn

      if (!this.timeoutId) {
        this.timeoutId = setTimeout(() => {
          this.lastCallTime = Date.now()
          this.timeoutId = null
          if (this.lastFn) {
            try {
              this.lastFn()
            } finally {
              this.lastFn = null
            }
          }
        }, remaining)
      }
    }
  }
}
